import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuthStore } from '@/stores/useAuthStore';
import { useAutoSelectEvent } from '@/hooks/useEvents';
import AppLayout from '@/components/layout/AppLayout';
import LoginPage from '@/pages/LoginPage';
import SignUpPage from '@/pages/SignUpPage';
import AcceptInvitePage from '@/pages/AcceptInvitePage';
import ForgotPasswordPage from '@/pages/ForgotPasswordPage';
import ResetPasswordPage from '@/pages/ResetPasswordPage';
import DashboardPage from '@/pages/DashboardPage';
import LeadsPage from '@/pages/LeadsPage';
import LeadDetailPage from '@/pages/LeadDetailPage';
import ManualEntryPage from '@/pages/ManualEntryPage';
import ScanCardPage from '@/pages/ScanCardPage';
import EnrichingPage from '@/pages/EnrichingPage';
import EventsPage from '@/pages/EventsPage';
import SettingsPage from '@/pages/SettingsPage';
import SuperAdminPage from '@/pages/SuperAdminPage';
import OutreachLandingPage from '@/pages/OutreachLandingPage';

export default function App() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  useAutoSelectEvent();

  return (
    <Routes>
      {/* Always-public routes — no auth required */}
      <Route path="/lp" element={<OutreachLandingPage />} />

      {!isAuthenticated ? (
        <>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<SignUpPage />} />
          <Route path="/invite" element={<AcceptInvitePage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </>
      ) : (
        <>
          <Route element={<AppLayout />}>
            <Route path="/" element={<DashboardPage />} />
            <Route path="/leads" element={<LeadsPage />} />
            <Route path="/leads/:id" element={<LeadDetailPage />} />
            <Route path="/scan" element={<ScanCardPage />} />
            <Route path="/new" element={<ManualEntryPage />} />
            <Route path="/enriching/:id" element={<EnrichingPage />} />
            <Route path="/events" element={<EventsPage />} />
            <Route path="/settings" element={<SettingsPage />} />
            <Route path="/super-admin" element={<SuperAdminPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
          <Route path="/login" element={<Navigate to="/" replace />} />
          <Route path="/signup" element={<Navigate to="/" replace />} />
          <Route path="/invite" element={<Navigate to="/" replace />} />
        </>
      )}
    </Routes>
  );
}
